import { formatInTimeZone } from 'date-fns-tz';

/** Converts a date string to the client's timezone. Assumed that input timezone is UTC.
 * @param utcDate - The date string in UTC timezone.
 * @param format - The format to return the date in. Options: https://date-fns.org/v4.1.0/docs/format
 */
export const formatUtcDateToLocalTimezone = (
  utcDate: string,
  format: string
): string => {
  const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; // Get the client's timezone
  const formattedDate = formatInTimeZone(utcDate, clientTimeZone, format);
  return formattedDate;
};
